import { useState } from 'react'

// local
import { IFilteredDoctorList } from 'types/HealthType'

export default function useAppointmentModal() {
  const [selectedDoc, setSelectedDoc] = useState<IFilteredDoctorList | undefined>()
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)

  const closeModal = () => setModal(false)
  const openModal = (doc?: IFilteredDoctorList) => {
    setModal(true)
    if (doc) setSelectedDoc(doc)
  }

  return { selectedDoc, setSelectedDoc, modal, openModal, closeModal, notification, setNotification }
}
